import Vue from "vue";
import Vuex from "vuex";
import authenication from "@/store/modules/Authenication";
import gameStore from "@/store/modules/GameStore";
import leaderBoardStore from "@/store/modules/LeaderBoardStore";
import cityStore from "@/store/modules/CityStore";
import toolBoxStore from "@/store/modules/ToolBoxStore";
import mapPoiStore from "@/store/modules/MapPoiStore";
import questStore from "@/store/modules/QuestStore";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  modules: {
    authenication,
    gameStore,
    leaderBoardStore,
    toolBoxStore,
    cityStore,
    mapPoiStore,
    questStore,
  },
  actions: {},
});

export default store;
